import { formatMoney } from '@betterment/core';
import { useGraphQLQuery } from '@betterment/graphql';
import { useToggledValue } from '@betterment/js-runtime';
import { Box, Card, Text, Tooltip } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { CompactCardLoader } from '../../Shared/components-v2/shimmer-loaders/compact-card-loader';
import { urlBuilder } from '../../Shared/urlBuilder';
import { NetWorthDocument } from '../net-worth/graphql/query.netWorth.generated';
import { NetWorthModal } from '../net-worth/NetWorthModal';

const performanceUrl = urlBuilder.appPerformance.absolute();

export default function NetWorthAndPerformance() {
  const rowCss = {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    '&:has(+ &)': {
      paddingBottom: 'space.100',
    },
  };
  const { data, error: hasError } = useGraphQLQuery(NetWorthDocument);
  const [isNetWorthModalOpen, toggleModalOpen] = useToggledValue(false);

  if (!data) return <CompactCardLoader />;

  if (hasError || !data.netWorth) {
    return null;
  }

  return (
    <Card data-testid="net-worth-performance-card" css={{ padding: 'space.300' }}>
      <Box css={rowCss}>
        <Box css={{ display: 'flex', gap: 'space.50' }}>
          <Text id="net-worth-performance-total-net-worth">Total net worth</Text>
          <Tooltip.IconButton aria-label="See net worth breakdown" onClick={toggleModalOpen} />
        </Box>
        <Text aria-describedby="net-worth-performance-total-net-worth">{formatMoney(data.netWorth.balance)}</Text>
      </Box>
      <Box css={rowCss}>
        <Text id="net-worth-performance-betterment-balance">{data.netWorth.internalSubtotal.name} balance</Text>
        <Text aria-describedby="net-worth-performance-betterment-balance">
          {formatMoney(data.netWorth.internalSubtotal.balance)}
        </Text>
      </Box>
      <Card.Footer css={{ marginTop: 'space.100' }}>
        <SambaAutoLink to={performanceUrl}>See performance</SambaAutoLink>
      </Card.Footer>
      {isNetWorthModalOpen && <NetWorthModal closeHandler={toggleModalOpen} netWorth={data.netWorth} />}
    </Card>
  );
}
